import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2543f65b = () => interopDefault(import('..\\pages\\about.vue' /* webpackChunkName: "pages/about" */))
const _473ac07a = () => interopDefault(import('..\\pages\\articles\\index.vue' /* webpackChunkName: "pages/articles/index" */))
const _6f0958ec = () => interopDefault(import('..\\pages\\aup.vue' /* webpackChunkName: "pages/aup" */))
const _7501891f = () => interopDefault(import('..\\pages\\careers\\index.vue' /* webpackChunkName: "pages/careers/index" */))
const _32c6c024 = () => interopDefault(import('..\\pages\\contact.vue' /* webpackChunkName: "pages/contact" */))
const _3bfc1486 = () => interopDefault(import('..\\pages\\disclaimer.vue' /* webpackChunkName: "pages/disclaimer" */))
const _495d1005 = () => interopDefault(import('..\\pages\\docs\\index.vue' /* webpackChunkName: "pages/docs/index" */))
const _44fbd120 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))
const _47e499e4 = () => interopDefault(import('..\\pages\\game-design-tool.vue' /* webpackChunkName: "pages/game-design-tool" */))
const _9c5568e2 = () => interopDefault(import('..\\pages\\games.vue' /* webpackChunkName: "pages/games" */))
const _f951bd7c = () => interopDefault(import('..\\pages\\glossary\\index.vue' /* webpackChunkName: "pages/glossary/index" */))
const _964942a0 = () => interopDefault(import('..\\pages\\learn\\index.vue' /* webpackChunkName: "pages/learn/index" */))
const _b12aa8e8 = () => interopDefault(import('..\\pages\\liveops-whitepaper.vue' /* webpackChunkName: "pages/liveops-whitepaper" */))
const _90b8f6d6 = () => interopDefault(import('..\\pages\\partners\\index.vue' /* webpackChunkName: "pages/partners/index" */))
const _ca1d2524 = () => interopDefault(import('..\\pages\\pricing\\index.vue' /* webpackChunkName: "pages/pricing/index" */))
const _2b63bcf3 = () => interopDefault(import('..\\pages\\search-results.vue' /* webpackChunkName: "pages/search-results" */))
const _0cb0c72c = () => interopDefault(import('..\\pages\\terms-and-conditions\\index.vue' /* webpackChunkName: "pages/terms-and-conditions/index" */))
const _efe7e828 = () => interopDefault(import('..\\pages\\community\\explore.vue' /* webpackChunkName: "pages/community/explore" */))
const _a5641f00 = () => interopDefault(import('..\\pages\\community\\see-all.vue' /* webpackChunkName: "pages/community/see-all" */))
const _e3f86bf6 = () => interopDefault(import('..\\pages\\docs\\search.vue' /* webpackChunkName: "pages/docs/search" */))
const _3ded7e66 = () => interopDefault(import('..\\pages\\resources\\academic-research-publications.vue' /* webpackChunkName: "pages/resources/academic-research-publications" */))
const _14a85b32 = () => interopDefault(import('..\\pages\\articles\\author\\_slugAuthor\\index.vue' /* webpackChunkName: "pages/articles/author/_slugAuthor/index" */))
const _01b6a307 = () => interopDefault(import('..\\pages\\articles\\category\\_slugCategory\\index.vue' /* webpackChunkName: "pages/articles/category/_slugCategory/index" */))
const _1bceb919 = () => interopDefault(import('..\\pages\\articles\\page\\_pageNumber.vue' /* webpackChunkName: "pages/articles/page/_pageNumber" */))
const _7937c9da = () => interopDefault(import('..\\pages\\careers\\job\\_jobSlug.vue' /* webpackChunkName: "pages/careers/job/_jobSlug" */))
const _1a65d486 = () => interopDefault(import('..\\pages\\articles\\author\\_slugAuthor\\page\\_pageNumber.vue' /* webpackChunkName: "pages/articles/author/_slugAuthor/page/_pageNumber" */))
const _71f81346 = () => interopDefault(import('..\\pages\\articles\\category\\_slugCategory\\page\\_pageNumber.vue' /* webpackChunkName: "pages/articles/category/_slugCategory/page/_pageNumber" */))
const _3341fc8a = () => interopDefault(import('..\\pages\\articles\\_slugPost.vue' /* webpackChunkName: "pages/articles/_slugPost" */))
const _673047e1 = () => interopDefault(import('..\\pages\\docs\\_docSlug.vue' /* webpackChunkName: "pages/docs/_docSlug" */))
const _fcbf000c = () => interopDefault(import('..\\pages\\glossary\\_slug.vue' /* webpackChunkName: "pages/glossary/_slug" */))
const _1ce4cfa2 = () => interopDefault(import('..\\pages\\learn\\_learnSlug.vue' /* webpackChunkName: "pages/learn/_learnSlug" */))
const _9875e166 = () => interopDefault(import('..\\pages\\community\\_communityUser\\profile.vue' /* webpackChunkName: "pages/community/_communityUser/profile" */))
const _3aa983a4 = () => interopDefault(import('..\\pages\\community\\_communityUser\\_userAction.vue' /* webpackChunkName: "pages/community/_communityUser/_userAction" */))
const _43452fd8 = () => interopDefault(import('..\\pages\\_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _2543f65b,
    pathToRegexpOptions: {"strict":true},
    name: "about___en___default"
  }, {
    path: "/articles",
    component: _473ac07a,
    pathToRegexpOptions: {"strict":true},
    name: "articles___en___default"
  }, {
    path: "/aup",
    component: _6f0958ec,
    pathToRegexpOptions: {"strict":true},
    name: "aup___en___default"
  }, {
    path: "/careers",
    component: _7501891f,
    pathToRegexpOptions: {"strict":true},
    name: "careers___en___default"
  }, {
    path: "/contact",
    component: _32c6c024,
    pathToRegexpOptions: {"strict":true},
    name: "contact___en___default"
  }, {
    path: "/disclaimer",
    component: _3bfc1486,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___en___default"
  }, {
    path: "/docs",
    component: _495d1005,
    pathToRegexpOptions: {"strict":true},
    name: "docs___en___default"
  }, {
    path: "/en",
    component: _44fbd120,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/game-design-tool",
    component: _47e499e4,
    pathToRegexpOptions: {"strict":true},
    name: "game-design-tool___en___default"
  }, {
    path: "/games",
    component: _9c5568e2,
    pathToRegexpOptions: {"strict":true},
    name: "games___en___default"
  }, {
    path: "/glossary",
    component: _f951bd7c,
    pathToRegexpOptions: {"strict":true},
    name: "glossary___en___default"
  }, {
    path: "/learn",
    component: _964942a0,
    pathToRegexpOptions: {"strict":true},
    name: "learn___en___default"
  }, {
    path: "/liveops-whitepaper",
    component: _b12aa8e8,
    pathToRegexpOptions: {"strict":true},
    name: "liveops-whitepaper___en___default"
  }, {
    path: "/partners",
    component: _90b8f6d6,
    pathToRegexpOptions: {"strict":true},
    name: "partners___en___default"
  }, {
    path: "/pricing",
    component: _ca1d2524,
    pathToRegexpOptions: {"strict":true},
    name: "pricing___en___default"
  }, {
    path: "/search-results",
    component: _2b63bcf3,
    pathToRegexpOptions: {"strict":true},
    name: "search-results___en___default"
  }, {
    path: "/terms-and-conditions",
    component: _0cb0c72c,
    pathToRegexpOptions: {"strict":true},
    name: "terms-and-conditions___en___default"
  }, {
    path: "/community/explore",
    component: _efe7e828,
    pathToRegexpOptions: {"strict":true},
    name: "community-explore___en___default"
  }, {
    path: "/community/see-all",
    component: _a5641f00,
    pathToRegexpOptions: {"strict":true},
    name: "community-see-all___en___default"
  }, {
    path: "/docs/search",
    component: _e3f86bf6,
    pathToRegexpOptions: {"strict":true},
    name: "docs-search___en___default"
  }, {
    path: "/en/about",
    component: _2543f65b,
    pathToRegexpOptions: {"strict":true},
    name: "about___en"
  }, {
    path: "/en/articles",
    component: _473ac07a,
    pathToRegexpOptions: {"strict":true},
    name: "articles___en"
  }, {
    path: "/en/aup",
    component: _6f0958ec,
    pathToRegexpOptions: {"strict":true},
    name: "aup___en"
  }, {
    path: "/en/careers",
    component: _7501891f,
    pathToRegexpOptions: {"strict":true},
    name: "careers___en"
  }, {
    path: "/en/contact",
    component: _32c6c024,
    pathToRegexpOptions: {"strict":true},
    name: "contact___en"
  }, {
    path: "/en/disclaimer",
    component: _3bfc1486,
    pathToRegexpOptions: {"strict":true},
    name: "disclaimer___en"
  }, {
    path: "/en/docs",
    component: _495d1005,
    pathToRegexpOptions: {"strict":true},
    name: "docs___en"
  }, {
    path: "/en/game-design-tool",
    component: _47e499e4,
    pathToRegexpOptions: {"strict":true},
    name: "game-design-tool___en"
  }, {
    path: "/en/games",
    component: _9c5568e2,
    pathToRegexpOptions: {"strict":true},
    name: "games___en"
  }, {
    path: "/en/glossary",
    component: _f951bd7c,
    pathToRegexpOptions: {"strict":true},
    name: "glossary___en"
  }, {
    path: "/en/learn",
    component: _964942a0,
    pathToRegexpOptions: {"strict":true},
    name: "learn___en"
  }, {
    path: "/en/liveops-whitepaper",
    component: _b12aa8e8,
    pathToRegexpOptions: {"strict":true},
    name: "liveops-whitepaper___en"
  }, {
    path: "/en/partners",
    component: _90b8f6d6,
    pathToRegexpOptions: {"strict":true},
    name: "partners___en"
  }, {
    path: "/en/pricing",
    component: _ca1d2524,
    pathToRegexpOptions: {"strict":true},
    name: "pricing___en"
  }, {
    path: "/en/search-results",
    component: _2b63bcf3,
    pathToRegexpOptions: {"strict":true},
    name: "search-results___en"
  }, {
    path: "/en/terms-and-conditions",
    component: _0cb0c72c,
    pathToRegexpOptions: {"strict":true},
    name: "terms-and-conditions___en"
  }, {
    path: "/resources/academic-research-publications",
    component: _3ded7e66,
    pathToRegexpOptions: {"strict":true},
    name: "resources-academic-research-publications___en___default"
  }, {
    path: "/en/community/explore",
    component: _efe7e828,
    pathToRegexpOptions: {"strict":true},
    name: "community-explore___en"
  }, {
    path: "/en/community/see-all",
    component: _a5641f00,
    pathToRegexpOptions: {"strict":true},
    name: "community-see-all___en"
  }, {
    path: "/en/docs/search",
    component: _e3f86bf6,
    pathToRegexpOptions: {"strict":true},
    name: "docs-search___en"
  }, {
    path: "/en/resources/academic-research-publications",
    component: _3ded7e66,
    pathToRegexpOptions: {"strict":true},
    name: "resources-academic-research-publications___en"
  }, {
    path: "/",
    component: _44fbd120,
    pathToRegexpOptions: {"strict":true},
    name: "index___en___default"
  }, {
    path: "/en/articles/author/:slugAuthor",
    component: _14a85b32,
    pathToRegexpOptions: {"strict":true},
    name: "articles-author-slugAuthor___en"
  }, {
    path: "/en/articles/category/:slugCategory",
    component: _01b6a307,
    pathToRegexpOptions: {"strict":true},
    name: "articles-category-slugCategory___en"
  }, {
    path: "/en/articles/page/:pageNumber?",
    component: _1bceb919,
    pathToRegexpOptions: {"strict":true},
    name: "articles-page-pageNumber___en"
  }, {
    path: "/en/careers/job/:jobSlug?",
    component: _7937c9da,
    pathToRegexpOptions: {"strict":true},
    name: "careers-job-jobSlug___en"
  }, {
    path: "/en/articles/author/:slugAuthor?/page/:pageNumber?",
    component: _1a65d486,
    pathToRegexpOptions: {"strict":true},
    name: "articles-author-slugAuthor-page-pageNumber___en"
  }, {
    path: "/en/articles/category/:slugCategory?/page/:pageNumber?",
    component: _71f81346,
    pathToRegexpOptions: {"strict":true},
    name: "articles-category-slugCategory-page-pageNumber___en"
  }, {
    path: "/articles/author/:slugAuthor",
    component: _14a85b32,
    pathToRegexpOptions: {"strict":true},
    name: "articles-author-slugAuthor___en___default"
  }, {
    path: "/articles/category/:slugCategory",
    component: _01b6a307,
    pathToRegexpOptions: {"strict":true},
    name: "articles-category-slugCategory___en___default"
  }, {
    path: "/articles/page/:pageNumber?",
    component: _1bceb919,
    pathToRegexpOptions: {"strict":true},
    name: "articles-page-pageNumber___en___default"
  }, {
    path: "/careers/job/:jobSlug?",
    component: _7937c9da,
    pathToRegexpOptions: {"strict":true},
    name: "careers-job-jobSlug___en___default"
  }, {
    path: "/en/articles/:slugPost",
    component: _3341fc8a,
    pathToRegexpOptions: {"strict":true},
    name: "articles-slugPost___en"
  }, {
    path: "/en/docs/:docSlug",
    component: _673047e1,
    pathToRegexpOptions: {"strict":true},
    name: "docs-docSlug___en"
  }, {
    path: "/en/glossary/:slug",
    component: _fcbf000c,
    pathToRegexpOptions: {"strict":true},
    name: "glossary-slug___en"
  }, {
    path: "/en/learn/:learnSlug",
    component: _1ce4cfa2,
    pathToRegexpOptions: {"strict":true},
    name: "learn-learnSlug___en"
  }, {
    path: "/en/community/:communityUser?/profile",
    component: _9875e166,
    pathToRegexpOptions: {"strict":true},
    name: "community-communityUser-profile___en"
  }, {
    path: "/articles/author/:slugAuthor?/page/:pageNumber?",
    component: _1a65d486,
    pathToRegexpOptions: {"strict":true},
    name: "articles-author-slugAuthor-page-pageNumber___en___default"
  }, {
    path: "/articles/category/:slugCategory?/page/:pageNumber?",
    component: _71f81346,
    pathToRegexpOptions: {"strict":true},
    name: "articles-category-slugCategory-page-pageNumber___en___default"
  }, {
    path: "/en/community/:communityUser?/:userAction?",
    component: _3aa983a4,
    pathToRegexpOptions: {"strict":true},
    name: "community-communityUser-userAction___en"
  }, {
    path: "/articles/:slugPost",
    component: _3341fc8a,
    pathToRegexpOptions: {"strict":true},
    name: "articles-slugPost___en___default"
  }, {
    path: "/docs/:docSlug",
    component: _673047e1,
    pathToRegexpOptions: {"strict":true},
    name: "docs-docSlug___en___default"
  }, {
    path: "/en/:slug",
    component: _43452fd8,
    pathToRegexpOptions: {"strict":true},
    name: "slug___en"
  }, {
    path: "/glossary/:slug",
    component: _fcbf000c,
    pathToRegexpOptions: {"strict":true},
    name: "glossary-slug___en___default"
  }, {
    path: "/learn/:learnSlug",
    component: _1ce4cfa2,
    pathToRegexpOptions: {"strict":true},
    name: "learn-learnSlug___en___default"
  }, {
    path: "/community/:communityUser?/profile",
    component: _9875e166,
    pathToRegexpOptions: {"strict":true},
    name: "community-communityUser-profile___en___default"
  }, {
    path: "/community/:communityUser?/:userAction?",
    component: _3aa983a4,
    pathToRegexpOptions: {"strict":true},
    name: "community-communityUser-userAction___en___default"
  }, {
    path: "/:slug",
    component: _43452fd8,
    pathToRegexpOptions: {"strict":true},
    name: "slug___en___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
